"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const core_1 = require("@material-ui/core/");
const react_redux_1 = require("react-redux");
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
const DrawArr = [
    {
        title: "Requester",
        data: log => { var _a, _b, _c, _d; return react_1.default.createElement("span", null, (_b = (_a = log === null || log === void 0 ? void 0 : log.data) === null || _a === void 0 ? void 0 : _a.requester) === null || _b === void 0 ? void 0 :
            _b.name,
            " (", (_d = (_c = log === null || log === void 0 ? void 0 : log.data) === null || _c === void 0 ? void 0 : _c.requester) === null || _d === void 0 ? void 0 :
            _d.email,
            ")"); }
    },
    {
        title: "Request Type",
        data: log => { var _a; return react_1.default.createElement("span", null, ((_a = log === null || log === void 0 ? void 0 : log.data) === null || _a === void 0 ? void 0 : _a.type) === 1 ? 'Service' : "Expert"); }
    },
    {
        title: "Query String",
        data: log => { var _a; return react_1.default.createElement("span", null, (_a = log === null || log === void 0 ? void 0 : log.data) === null || _a === void 0 ? void 0 : _a.q); }
    },
    {
        title: "Selected Filters",
        data: log => {
            var _a;
            const logs = groupBy_1.default(uniqBy_1.default((_a = log === null || log === void 0 ? void 0 : log.data) === null || _a === void 0 ? void 0 : _a.filters, 'sub_cat_id'), "cat_name");
            return Object.keys(logs).map((prop, key) => {
                return (react_1.default.createElement("div", { key: key },
                    react_1.default.createElement("h5", null, prop || "Generic"),
                    react_1.default.createElement("div", null, logs[prop].map((val, key) => react_1.default.createElement(core_1.Chip, { style: { margin: '2px' }, key: key, size: "small", label: val.sub_cat_name })))));
            });
        }
    },
    {
        title: "Selected States",
        data: log => {
            var _a;
            return uniqBy_1.default((_a = log === null || log === void 0 ? void 0 : log.data) === null || _a === void 0 ? void 0 : _a.states, 'id')
                .map((val, key) => react_1.default.createElement(core_1.Chip, { style: { margin: '2px' }, key: key, size: "small", label: val.name }));
        }
    },
    {
        title: "Selected Languages",
        data: log => {
            var _a;
            return uniqBy_1.default((_a = log === null || log === void 0 ? void 0 : log.data) === null || _a === void 0 ? void 0 : _a.languages, 'id')
                .map((val, key) => react_1.default.createElement(core_1.Chip, { style: { margin: '2px' }, key: key, size: "small", label: val.name }));
        }
    },
    {
        title: "Response Count",
        data: log => { var _a; return react_1.default.createElement("span", null, (_a = log === null || log === void 0 ? void 0 : log.data) === null || _a === void 0 ? void 0 : _a.responseCount); }
    }
];
const LogInfo = (props) => {
    const { open, log } = props;
    const closeModal = () => {
        props.viewLog(null);
        props.triggerModal({ key: 'experts.queryLogs', val: false });
    };
    return (react_1.default.createElement(core_1.Dialog, { open: open, maxWidth: 'sm', fullWidth: true, onClose: () => closeModal() }, log && react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.DialogTitle, { id: "form-dialog-title" }, "Log Info"),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement("div", { style: { marginTop: "10px" } }, DrawArr.map((val, key) => {
                return (react_1.default.createElement("div", { key: key },
                    react_1.default.createElement("p", { style: { fontWeight: "bold" } }, val.title),
                    react_1.default.createElement("div", null, val.data(log)),
                    react_1.default.createElement(core_1.Divider, { style: { margin: "10px 0" } })));
            }))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: () => closeModal(), color: "primary" }, "Close")))));
};
const mapStateToProps = (state) => {
    const { modals, experts } = state;
    return {
        open: modals.ADMIN.experts.queryLogs,
        log: experts.viewLog
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
        viewLog: (data) => dispatch(expertsSlice_1.viewLog(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LogInfo);
